import { render, staticRenderFns } from "./PengajuanRekomendasiDokumen.vue?vue&type=template&id=7d5c3616&"
import script from "./PengajuanRekomendasiDokumen.vue?vue&type=script&lang=js&"
export * from "./PengajuanRekomendasiDokumen.vue?vue&type=script&lang=js&"
import style0 from "./PengajuanRekomendasiDokumen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports